import Vue from 'vue'
import Element from 'element-ui'
import '../assets/element-theme/index.css'

import i18n from '../lang' // Internationalization

Vue.use(Element, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})



// WEBPACK FOOTER //
// ./src/plugin/element-ui.js